export const skill = {
  techskills: [
    "Spring MVC",
    "Hibernate",
    "Java",
    "Spring JPA",
    "SQL-MySQL",
    "Spring Boot",
    "Python",
    "C",
    "Office",
    "AutoCAD",
    "React",
    "Javascript",
  ],
};
